export const initialFilterParks = {
  master_location_id: 0,
  master_animal_id: 0,
  master_vehicle_id: 0,
  master_animal_slug: 0,
  custom_sort_by: 0,
  accomodation_id: 0,
  bonus_experience_id: 0
};

export const initialFilterParksWise = {
  master_animal_id: 0,
  master_vehicle_id: 0,
  master_animal_slug: 0,
  custom_sort_by: 0,
  accomodation_id: 0,
  bonus_experience_id: 0

};

export const initialSummary = {
  total: 0,
  page: 1,
  pageSize: 12,
  total_page: 1,
};

export const raInitialFilterParks = {
  custom_sort_by: 0,
  accomodation_id: 0,
  bonus_experience_id: 0
};